var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import C from 'classnames';
export const Table = (_a) => {
    var { className, striped, bordered, hover, children, style } = _a, props = __rest(_a, ["className", "striped", "bordered", "hover", "children", "style"]);
    return (React.createElement("table", Object.assign({ className: C('table', className, striped && 'table-striped', bordered && 'table-bordered', hover && 'table-hover'), style: style }, props), children));
};
//# sourceMappingURL=Table.js.map